import React from "react";
import { Handle } from "reactflow";
import { PiTreeStructureDuotone } from "react-icons/pi";
const DataSplitterNode = ({ id, data }) => {
  return (
    <div className="bg-zinc-800 text-zinc-100 rounded-lg shadow-md border w-72">
      <div className="py-2 px-4 border-b border-zinc-700 flex items-center gap-2">
        <PiTreeStructureDuotone className="rotate-90 text-2xl" />
        <p className="font-semibold text-md">Data Splitter</p>
      </div>
      <p className="py-2 px-4 text-sm flex flex-col border-b border-zinc-700 ">
        <span className="text-zinc-400 mb-1 text-xs text-left font-medium w-full">
          Purpose:
        </span>{" "}
        <span className="text-xs text-left max-w-full overflow-hidden">
          {data.purpose.length > 60
            ? `${data.purpose.slice(0, 60)}...`
            : data.purpose}
        </span>
      </p>

      <div className="py-2 px-4 text-xs">
        <span className="text-zinc-400 mb-1 text-xs text-left font-medium w-full">
          Levels:
        </span>{" "}
        <ul className="list-disc pl-4">
          {data.levels &&
            data.levels.map((level, index) => (
              <li key={level.id}>
                <strong>Level {index}:</strong>{" "}
                {level.description || "No description"}
              </li>
            ))}
        </ul>
      </div>
      <Handle
        type="target"
        position="left"
        className="bg-yellow-400 border-none"
        style={{
          left: "-6px",
          top: "50%",
          transform: "translateY(-50%)",
          height: "10px",
          width: "10px",
        }}
      />
      <Handle
        type="source"
        position="right"
        className="bg-blue-400 border-none"
        style={{
          right: "-6px",
          top: "50%",
          transform: "translateY(-50%)",
          height: "10px",
          width: "10px",
        }}
      />
    </div>
  );
};

export default DataSplitterNode;
